import { useQuery } from '@apollo/client';
import { MY_MENTORSHIPS_QUERY } from '../graphql/resolvers/vouchQueries/myMentorships.gql';

export function useMentorships() {
  const { data, loading, refetch } = useQuery(MY_MENTORSHIPS_QUERY, {
    fetchPolicy: 'cache-and-network',
    skip: import.meta.env.VITE_ENABLE_VOUCHING !== 'true',
  });
  return { mentorships: data?.myMentorships ?? [], loading, refetch };
}
